export default (backInStock, url, section, selectedVariantId) => ({
  options: null,
  variantData: null,
  currentVariantId: selectedVariantId,
  currentVariantAvailable: false,
  showBackInStock: backInStock,
  currentVariantTitle: null,
  url: url,
  section: section,
  available: true,
  addToCartText: null,
  soldOutText: null,
  sizeOptionText: null,
  chooseASize: false,
  productHandle: null,
  productId: null,
  variantInventoryQuantity: null,
  variants: [],

  initVariants(variant) {
    console.log("initVariants called", variant);
    
    if (!variant) this.chooseASize = true;
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );
    this.sizeOptionText = this.options[1];
    if (this.sizeOptionText === "ONESI") {
      this.sizeOptionText = "Onesize";
    }

    // Always initialize store data on page load
    const urlParams = new URLSearchParams(window.location.search);
    const nostoParam = urlParams.get("nosto");
    const refSrcParam = urlParams.get("refSrc");
    const currentStoreData = Alpine.store("nostoState").data || {};

    // Set initial store data, preserving any existing data
    Alpine.store("nostoState").set({
      ...currentStoreData,
      attributionKey: currentStoreData.attributionKey || nostoParam || null,
      refSrc: currentStoreData.refSrc || refSrcParam || null,
    });

    console.log(
      "Initialized store data on page load:",
      Alpine.store("nostoState").data
    );

    if (!variant) {
      this.chooseASize = true;
      return;
    }

    this.updateOptions();
  },

  updateOptions(template) {
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );

    this.sizeOptionText = this.options[1];
    if (this.sizeOptionText === "ONESI") {
      this.sizeOptionText = "Onesize";
    }

    this.updateMasterId();

    if (template === "product") {
      this.updateURL();
    }
    this.renderProductInfo();
    this.chooseASize = false;

    // Get current store data
    const storeData = Alpine.store("nostoState").data || {};
    const variantId = this.getVariantData()
      .find(
        (variant) =>
          !variant.options
            .map((option, index) => this.options[index] === option)
            .includes(false)
      )
      ?.id?.toString();

    // Update store with new variant data
    Alpine.store("nostoState").set({
      ...storeData,
    });

    console.log("Updated store data:", Alpine.store("nostoState").data);
  },

  updateMasterId() {
    let variantObj = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    this.currentVariantId = variantObj.id;
    this.currentVariantAvailable = variantObj.available;
    this.currentVariantTitle = variantObj.title;
  },

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    return this.variantData;
  },

  updateURL() {
    const storeData = Alpine.store("nostoState").data || {};
    const variantId = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false)
    )?.id;

    if (!variantId) return;

    // Check if we are on a product page
    const isProductPage = window.location.pathname.includes("/products/");

    if (isProductPage) {
      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;

      // Check if refSrc or nosto exists in the URL
      const hasRefSrc = searchParams.has("refSrc");
      const hasNosto = searchParams.has("nosto");

      if (hasRefSrc || hasNosto) {
        // Handle refSrc parameter
        if (hasRefSrc) {
          const currentRefSrc = searchParams.get("refSrc");
          // Get the product ID (not variant ID) from the current variant
          const productId = this.getVariantData().find(
            (variant) => variant.id === variantId
          )?.product_id;

          // Only update refSrc if we have a product ID and it's different from current
          if (productId && currentRefSrc !== productId.toString()) {
            searchParams.set("refSrc", productId.toString());
          }
        }

        // Handle nosto parameter
        const currentNosto = searchParams.get("nosto");
        // Only update nosto if we have a new attribution key and it's different
        if (
          storeData.attributionKey &&
          currentNosto !== storeData.attributionKey
        ) {
          searchParams.set("nosto", storeData.attributionKey);
        }

        // Always update the variant parameter
        searchParams.set("variant", variantId);
        window.history.replaceState({}, "", currentUrl.toString());
      }
    } else if (storeData.attributionKey && !isProductPage) {
      // Use the original logic for simple variant URLs
      window.history.replaceState(
        {},
        "",
        `${this.url}?nosto=${storeData.attributionKey}&variant=${variantId}`
      );
    } else {
      // Use the original logic for simple variant URLs
      window.history.replaceState(
        {},
        "",
        `${this.url}?variant=${variantId}`
      );
    }

    // Update store with new variant data, but preserve currentUrl
    Alpine.store("nostoState").set({
      ...storeData,
    });
  },

  renderProductInfo() {
    fetch(`${this.url}?variant=${this.currentVariantId}&section_id=${this.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        this.getElementsToRender().forEach((element) => {
          const dest = document.getElementById(element.id);
          const src = html.getElementById(element.id);

          if (src && dest) {
            switch (element.type) {
              case "innerHTML":
                dest.innerHTML = src.innerHTML;
                break;
              case "value":
                dest.value = src.value;
                break;
            }
          }
        });


        const sourceCartNotice = html.getElementById(`cn-${this.section}`);
        const sourceAPrice = html.getElementById(`ap-${this.section}`);
        const sourceQuickshopAPrice = html.getElementsByName(
          `properties[_actualprice]`
        );

       
        const destCartNotice = document.getElementById(`cn-${this.section}`);
        if (sourceCartNotice && destCartNotice)
          destCartNotice.innerHTML = sourceCartNotice.innerHTML;
      });
  },

  isVariantAvailable(text) {
    const variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    const variant = variantData.find((variant) => variant.option2 === text);
    if (variant) {
      if (variant.available) {
        return true;
      }
      return false;
    }
  },

  setVariants(id, quantity, available) {
    this.variants.push({
      id: id,
      quantity: quantity,
      available: available,
    });
  },

  getElementsToRender() {
    return [
      {
        id: `price-${this.section}`,
        type: "innerHTML",
      },
      {
        id: `ProductSubmitButton-wrapper-${this.section}`,
        type: "innerHTML",
      },
      {
        id: `inventory-${this.section}`,
        type: "innerHTML",
      },
    ];
  }
});
